import { cssToDom, isArray, capitalize, hyphenate } from 'omi/src/util'
import { diff } from 'omi/src/vdom/diff'
import { WeElement, options } from 'omi/src/omi'
import { createStyleSheets, createStyleSheet, handleAdoptedStyleSheets, handleStyleSheets } from './stylesheet'
import updateTargets from './updateTargets'
import { throttle } from 'throttle-debounce'
const UpdateInterval = 13
export default class extends WeElement {

    async connectedCallback() {
        let p = this.parentNode
        while (p && !this.store) {
            this.store = p.store
            p = p.parentNode || p.host
        }

        if (this.inject) {
            this.injection = {}
            p = this.parentNode
            let provide
            while (p && !provide) {
                provide = p.provide
                p = p.parentNode || p.host
            }
            if (provide) {
                this.inject.forEach(injectKey => {
                    this.injection[injectKey] = provide[injectKey]
                })
            } else {
                throw 'The provide prop was not found on the parent node or the provide type is incorrect.'
            }
        }

        this.attrsToProps()

        await this.beforeInstall()

        if (typeof this.props.settings == "object") {
            this.settings = this.props.settings
            if (this.constructor.defaultProps) {
                for (let dp in this.constructor.defaultProps) {
                    if (!this.settings.hasOwnProperty(dp)) {
                        this.settings[dp] = this.constructor.defaultProps[dp]
                    }
                }
            }

        } else {
            this.settings = this.props
        }
        
        await this.install()
        await this.afterInstall()

        let shadowRoot
        if (this.constructor.isLightDom) {
            shadowRoot = this
        } else {
            if (!this.shadowRoot) {
                shadowRoot = this.attachShadow({
                    mode: 'open'
                })
            } else {
                shadowRoot = this.shadowRoot
                let fc
                while ((fc = shadowRoot.firstChild)) {
                    shadowRoot.removeChild(fc)
                }
            }
        }

        //20220805，如果 CSSStyleSheet是引用形式的，那么可以创建一个特殊的对象用于共享一组初始样式。

        if (this.constructor.elementStyles) {
            shadowRoot.adoptedStyleSheets = this.constructor.elementStyles
        } else {
            let styleSheets = await handleAdoptedStyleSheets(this.constructor.css)
            if (styleSheets.length > 0) {
                this.constructor.elementStyles = shadowRoot.adoptedStyleSheets = styleSheets
            }


        }


        //saharan
        //支持样式表导入，样式表的优势是相对路径
        let stylesheets = await handleStyleSheets(this.constructor.stylesheets, this)
        createStyleSheets(stylesheets).forEach((link) => {
            shadowRoot.appendChild(link);
        });

        await this.beforeRender()
        options.afterInstall && await options.afterInstall(this)

        const rendered = await this.render(this.props, this.store)

        this.rootNode = diff(null, rendered, null, this)
        await this.rendered()


        /**
         * 2022-7-27,
         * ljj 
         * 可以更新css默認設置
         */

        this.updateStyle();


        if (isArray(this.rootNode)) {
            this.rootNode.forEach(function (item) {
                shadowRoot.appendChild(item)
            })
        } else {
            this.rootNode && shadowRoot.appendChild(this.rootNode)
        }
        await this.installed()
        this.isInstalled = true
    }
    async disconnectedCallback() {
        await this.uninstall()
        this.isInstalled = false
    }
    async updateStyle() {
        if (this.css) {
            let cssContent = (await handleStyleSheets(this.css, this)).join('\n')
            if (!this._defaultStyleElement) {
                this._defaultStyleElement = cssToDom(cssContent)
                this.shadowRoot.appendChild(this._defaultStyleElement)
            } else if (this._defaultStyleElement.textContent != cssContent) {
                this._defaultStyleElement.textContent = cssContent;
                // console.log('default css updated')

            }
            // console.log("default css equal ", this._defaultStyleElement?.textContent == cssContent)

        }

        if (this.props.css) {//this 可能应该是父组件

            let cssContent = (await handleStyleSheets(this.props.css, this.shadowRoot?.host)).join('\n')
            if (!this._customStyleElement) {
                this._customStyleElement = cssToDom(cssContent)
                // this._customStyleContent = this.props.css
                this.shadowRoot.appendChild(this._customStyleElement)
            } else if (this._customStyleElement.textContent != cssContent) {
                this._customStyleElement.textContent = cssContent
                // console.log('props css updated')
            }
            // console.log("props css equal ", this._customStyleElement?.textContent == this.props.css)

        }

        let stylesheets = []
        if (this.stylesheets) {
            stylesheets = await handleStyleSheets(this.stylesheets, this)
        }
        if (this.props.stylesheets) { //this 可能应该是父组件
            stylesheets = stylesheets.concat(await handleStyleSheets(this.props.stylesheets, this.shadowRoot?.host))
        }

        let stylesheetMap = this._stylesheetMap ?? (this._stylesheetMap = new Map())

        let exsistStylesheets = new Set(stylesheetMap.keys())
        stylesheets.forEach(href => {
            if (!stylesheetMap.has(href)) {
                let stylesheetEle = createStyleSheet(href)
                this.shadowRoot.appendChild(stylesheetEle);
                stylesheetMap.set(href, stylesheetEle)
            }
            exsistStylesheets.delete(href)
        })
        //need delete link
        exsistStylesheets.forEach(href => {
            let link = stylesheetMap.get(href)
            if (link) {
                this.shadowRoot.removeChild(link)
                stylesheetMap.delete(href)
            }
        })


    }

    /**
     * 更新指定的对象
     * @param {*} targets 
     */
    updateTargets(targets, ignoreAttrs = true, cascade = true) {
        updateTargets(targets, this.shadowRoot, ignoreAttrs, cascade)
    }

    async update(ignoreAttrs, updateSelf) {
        if (this._willUpdate === true) return
        this._willUpdate = true
        try {
            await this.beforeUpdate()
            await this.beforeRender()

            this.attrsToProps(ignoreAttrs)
            const rendered = await this.render(this.props, this.store)

            await this.rendered()

            this.rootNode = diff(
                this.rootNode,
                rendered,
                this.constructor.isLightDom ? this : this.shadowRoot,
                this,
                updateSelf
            )

            //fix null !== undefined
            // 20220803 saharan
            this.updateStyle()
        }
        finally {
            this._willUpdate = false
            await this.updated()
        }
    }
    lazyUpdate = throttle(UpdateInterval, (ignoreAttrs, updateSelf) => {
        this.update(ignoreAttrs, updateSelf)
    })

    updateSelf(ignoreAttrs) {
        this.update(ignoreAttrs, true)
    }
    forceUpdate() {
        this.update(true)
    }
    forceUpdateSelf() {
        this.update(true, true)
    }

    // updateAttrs(obj) {
    //     Object.keys(obj).forEach(key => {
    //         let val = obj[key];
    //         this.props[key] = val
    //         if (this.prevProps) {
    //             this.prevProps[key] = val
    //         }
    //         this.setAttribute(key, val)
    //     })
    // }

    updateProps(obj, ignoreAttrs = true, updateSelf = false, updateAttrs = false) {
        Object.keys(obj).forEach(key => {
            let value = obj[key]
            this.props[key] = value
            if (this.prevProps) {
                this.prevProps[key] = value
            }
            if (updateAttrs) {
                this.setAttribute(key, value)
            }
        })
        this.update(ignoreAttrs, updateSelf)
    }

    updateSettings(obj, ignoreAttrs = true, updateSelf = false, updateAttrs = false) {
        Object.keys(obj).forEach(key => {
            let value = obj[key]
            this.props[key] = value
            this.settings[key] = value
            if (this.prevProps) {
                this.prevProps[key] = value
            }
            if (updateAttrs) {
                this.setAttribute(key, value)
            }
        })
        this.update(ignoreAttrs, updateSelf)
    }
    /**
     * 默认监控所有定义的属性
     */
    static get observedAttributes() {
        return this.updateOnAttributeChanged && this.propTypes ? Object.keys(this.propTypes).map(hyphenate) : []
    }

    attributeChangedCallback(attr, oldVal, newVal) {
        if (this.isInstalled && this._willUpdate !== true && this.updateOnAttributeChanged !== false)
            this.lazyUpdate();
    }



    //20220802 修改后不会两次render
    //不再自动刷新，由attributeChangedCallback 决定
    // removeAttribute(key) {
    //     let attKey = hyphenate(key)
    //     super.pureRemoveAttribute(attKey)
    //     //Avoid executing removeAttribute methods before connectedCallback
    //     //this.isInstalled && await this.updateSelf()
    // }
    // //20220802 修改后不会两次render
    // //测试一下要是
    // //不再自动刷新，由attributeChangedCallback 决定

    // setAttribute(key, val) {
    //     let attKey = hyphenate(key)
    //     if (val && typeof val === 'object') {
    //         super.pureSetAttribute(attKey, JSON.stringify(val))
    //     } else {
    //         super.pureSetAttribute(attKey, val)
    //     }
    //     //Avoid executing setAttribute methods before connectedCallback
    //     //this.isInstalled && await this.updateSelf()
    // }
    // getAttribute(key) {
    //     let attKey = hyphenate(key)
    //     return super.getAttribute(attKey);
    // }

    fire(name, data, cancelable = false, bubbles = false) {
        let customEvent = new CustomEvent(name, {
            detail: data,
            cancelable,
            bubbles
        })
        const handler = this.props[`on${capitalize(name)}`]
        if (handler) {
            handler(customEvent)

        } else {
            this.dispatchEvent(customEvent)
        }
    }


    $$(selector) {
        return [...(this.shadowRoot ?? this).querySelectorAll(selector)];
    }
    $(selector) {
        return (this.shadowRoot ?? this).querySelector(selector);
    }

    beforeInstall() { }

    install() { }

    afterInstall() { }

    installed() { }

    uninstall() { }

    beforeUpdate() { }

    updated() { }

    beforeRender() { }

    rendered() { }

    receiveProps() { }
}
